// Cook-type filter values shared by the Cook list and the Cook serve calendar.
// ACTIVE_PART_TIME = non-MG (part-time) cook, onboarding complete, with an SLC service mapping.
export enum CookTypeFilter {
  MG_COOK = "MG_COOK",
  PART_TIME = "PART_TIME",
  ACTIVE_PART_TIME = "ACTIVE_PART_TIME",
}
